export default {"src":"/evde-internet/_next/static/media/arrow_left.54c5c432.svg","height":24,"width":24};